// extracted by mini-css-extract-plugin
export default {"mainCardContainer":"MainCard_mainCardContainer__aLYBU"};